var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 593,
    viewBox: "0 0 1440 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2924_4190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1312,
    y: 0,
    width: 128,
    height: 187
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1312,
    width: 128,
    height: 187,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2924_4190)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1312,
    y: 64.5789,
    width: 58.9474,
    height: 58.9474,
    rx: 2,
    fill: "url(#paint0_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1393.05,
    y: 13,
    width: 73.6842,
    height: 73.6842,
    rx: 2,
    fill: "url(#paint1_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1407.79,
    y: 108.789,
    width: 44.2105,
    height: 44.2105,
    rx: 2,
    fill: "url(#paint2_linear_2924_4190)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2924_4190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 406,
    width: 128,
    height: 187
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 593,
    width: 128,
    height: 187,
    transform: "rotate(180 128 593)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2924_4190)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 528.421,
    width: 58.9474,
    height: 58.9474,
    rx: 2,
    transform: "rotate(180 128 528.421)",
    fill: "url(#paint3_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9474,
    y: 580,
    width: 73.6842,
    height: 73.6842,
    rx: 2,
    transform: "rotate(180 46.9474 580)",
    fill: "url(#paint4_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2105,
    y: 484.211,
    width: 44.2105,
    height: 44.2105,
    rx: 2,
    transform: "rotate(180 32.2105 484.211)",
    fill: "url(#paint5_linear_2924_4190)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2924_4190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 85,
    width: 47,
    height: 55
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273.644,
    y: 140,
    width: 46.2871,
    height: 55,
    transform: "rotate(180 273.644 140)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2924_4190)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.716,
    y: 121.006,
    width: 17.3375,
    height: 17.3375,
    rx: 2,
    transform: "rotate(180 273.716 121.006)",
    fill: "url(#paint6_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.877,
    y: 136.176,
    width: 21.6718,
    height: 21.6718,
    rx: 2,
    transform: "rotate(180 249.877 136.176)",
    fill: "url(#paint7_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.543,
    y: 108.003,
    width: 13.0031,
    height: 13.0031,
    rx: 2,
    transform: "rotate(180 245.543 108.003)",
    fill: "url(#paint8_linear_2924_4190)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2924_4190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1043,
    y: 290,
    width: 47,
    height: 55
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1089.29,
    y: 345,
    width: 46.2871,
    height: 55,
    transform: "rotate(180 1089.29 345)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2924_4190)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1089.36,
    y: 326.006,
    width: 17.3375,
    height: 17.3375,
    rx: 2,
    transform: "rotate(180 1089.36 326.006)",
    fill: "url(#paint9_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.52,
    y: 341.176,
    width: 21.6718,
    height: 21.6718,
    rx: 2,
    transform: "rotate(180 1065.52 341.176)",
    fill: "url(#paint10_linear_2924_4190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1061.19,
    y: 313.003,
    width: 13.0031,
    height: 13.0031,
    rx: 2,
    transform: "rotate(180 1061.19 313.003)",
    fill: "url(#paint11_linear_2924_4190)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2924_4190",
    x1: 1312.92,
    y1: 75.8326,
    x2: 1370.25,
    y2: 76.7748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2924_4190",
    x1: 1394.2,
    y1: 27.067,
    x2: 1465.87,
    y2: 28.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2924_4190",
    x1: 1408.48,
    y1: 117.23,
    x2: 1451.48,
    y2: 117.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2924_4190",
    x1: 128.921,
    y1: 539.675,
    x2: 186.254,
    y2: 540.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2924_4190",
    x1: 48.0987,
    y1: 594.067,
    x2: 119.765,
    y2: 595.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2924_4190",
    x1: 32.9013,
    y1: 492.651,
    x2: 75.9011,
    y2: 493.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2924_4190",
    x1: 273.987,
    y1: 124.316,
    x2: 290.85,
    y2: 124.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2924_4190",
    x1: 250.216,
    y1: 140.314,
    x2: 271.294,
    y2: 140.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2924_4190",
    x1: 245.746,
    y1: 110.485,
    x2: 258.393,
    y2: 110.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2924_4190",
    x1: 1089.63,
    y1: 329.316,
    x2: 1106.49,
    y2: 329.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2924_4190",
    x1: 1065.86,
    y1: 345.314,
    x2: 1086.94,
    y2: 345.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2924_4190",
    x1: 1061.39,
    y1: 315.485,
    x2: 1074.04,
    y2: 315.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerWhite);
export default __webpack_public_path__ + "static/media/banner-white.88a897547a678049ccef362c98b81973.svg";
export { ForwardRef as ReactComponent };